import {gsap, ScrollTrigger} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class PageScroll {
    constructor() {
        this.sidebar = document.querySelector(".sidebar");
        this.banner = document.querySelector(".banner");
        this.bannerContent = document.querySelector(".banner .banner-content");
        this.bannerMedia = document.querySelector(".banner .banner-media");
        this.bannerImageContainer = document.querySelector(".banner .banner-image-container");
        this.strates = document.querySelectorAll(".sidebar .sidebar-strat");
        let needResize = false;

        if (!document.body.classList.contains("no-reveal") && this.sidebar && this.banner) {
            this.bannerScrollAnimation();
            needResize = true;
        }

        if (this.strates) {
            this.sidebarStratesAnimation();
            needResize = true;
        }

        if (needResize) {
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    bannerScrollAnimation() {
        if (this.tlLayoutChange) {
            this.tlLayoutChange.kill();
            gsap.set([this.sidebar, this.banner, this.bannerContent, this.bannerMedia, this.bannerImageContainer], {clearProps: "all"});
        }

        // Timeline basé sur la bannière
        this.tlLayoutChange = gsap.timeline({
            scrollTrigger: {
                trigger: this.banner,
                start: "top top",
                scrub: true,
                overwrite: true,
                invalidateOnRefresh: true
            },
        });

        // Start
        this.tlLayoutChange.addLabel("start");

        // Sidebar
        if (window.innerWidth > 990) {
            this.tlLayoutChange.to(this.sidebar, {
                width: window.innerWidth * 0.15
            }, "start");
        }

        // Contenu de la bannière
        if (this.bannerContent && window.innerWidth > 990) {
            this.tlLayoutChange.to(this.bannerContent, {marginLeft: 0}, "start");

            if (this.bannerImageContainer) {
                this.tlLayoutChange.to(this.bannerImageContainer, {marginLeft: 0}, "start");
                // this.tlLayoutChange.to(this.bannerImageContainer.querySelector(".banner-image-scale"), {scale: 1.1}, "start");
            }
        }

        // Media
        if (this.bannerMedia) {
            this.tlMedia = gsap.timeline({
                scrollTrigger: {
                    startTrigger: document.querySelector(".page-container"),
                    start: "top top",
                    endTrigger: document.querySelector(".main-content"),
                    end: "top top",
                    scrub: true,
                    overwrite: true,
                },
            });
            this.tlMedia.to(this.bannerMedia, {
                scale: 1.1,
                y: "-40%"
            });

            gsap.to(this.bannerMedia, {
               opacity: 0,
               scrollTrigger: {
                   trigger: document.querySelector(".main-content"),
                   start: "top bottom",
                   end: "top top",
                   scrub: true,
               }
            });
        }
    }

    sidebarStratesAnimation() {
        if (this.tlSidebarStrates) {
            this.tlSidebarStrates.kill();
            gsap.set([this.strates], {clearProps: "all"});
        }

        // Timeline basé sur la bannière
        this.tlSidebarStrates = gsap.timeline({
            scrollTrigger: {
                trigger: document.querySelector(".page-container"),
                start: "top top",
                end: "bottom top",
                scrub: true,
                overwrite: true,
            },
        });

        // Strates
        this.strates.forEach(strate => {
            this.tlSidebarStrates.to(strate, {scaleY: 1.6}, "start");
        });
    }

    resize() {
        if (this.tlLayoutChange) {
            this.bannerScrollAnimation();
        }

        if (this.tlSidebarStrates) {
            this.sidebarStratesAnimation();
        }

        if (this.tlSidebarStrates || this.tlLayoutChange) {
            ScrollTrigger.refresh();
        }
    }
}